import { Alert, Box, Chip, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import { useUserStore } from "../../../store/UserStore";
import { usePageController } from "../../../store/PageController";
import { calculateTrialDaysLeft } from "../../../utils/commonFunc";

const Introduction = () => {
  const user = useUserStore((state) => state.user);

  const smallerThan900 = useMediaQuery("(min-width:900px");
  const smallerThan1320 = useMediaQuery("(min-width:1320px");
  const setCurrentComponent = usePageController(
    (state) => state.setCurrentComponent
  );

  const getStartedHandler = () => {
    setCurrentComponent("create");
  };

  const showAlertMessage = () => {
    if (user?.paidstatus === 0) {
      const daysLeft = Number(calculateTrialDaysLeft(user.activationdate));

      if (daysLeft > 0) {
        return `${daysLeft} day(s) left before your free trial ends and you will be charged.`;
      } else if (daysLeft === 0) {
        return "Your free trial ends today. You will be charged tomorrow!";
      } else {
        return "Your free trial has ended. You have been charged.";
      }
    }
  };
  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      gap={"1rem"}
      width={smallerThan1320 ? "1064px" : "calc(90vw - 180px)"}
      sx={{ height: "calc(100lvh - 161px)" }}
    >
      {user?.paidstatus === 0 && (
        <Alert
          severity="info"
          variant="filled"
          sx={{ "& .MuiAlert-message": { fontSize: "1rem" } }}
        >
          {showAlertMessage()}
        </Alert>
      )}
      <Typography variant="title">
        Welcome {user ? user.firstname : ""}!
      </Typography>

      <Typography variant="body1">
        Thank you for choosing Rawdat.AI as your serverless platform of choice.
        By using Rawdat.AI, you agree to our <a href="https://rawdat.ai/policies/terms_of_use.pdf"><b>Terms</b></a>&nbsp; 
        and have read our <a href="https://rawdat.ai/policies/privacy_policy.pdf"><b>Privacy Policy</b></a>.
        Clicking on <span className="bold">‘Getting Started’</span> will direct
        you to the <span className="bold">‘Create’</span> tab where you can
        start deploying your functions.
        <br />
        <br />
        You can navigate to the documentation section for more details on using
        the platform. We hope you enjoy using Rawdat.AI and we very much value
        your feedback. Enjoy!
      </Typography>

      <Chip
        color={"primary"}
        label={"Getting Started"}
        onClick={getStartedHandler}
        sx={{
          width: 160,
          cursor: "pointer",
          "& .MuiChip-label": { fontSize: "16px", fontWeight: 400 },
        }}
      />
    </Box>
  );
};

export default Introduction;
